import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const initialState = {
    data: {},
    rows: {},
    isLoading: false,

    pieces: [],
    bundles: [],
};

export const useMassalStore = create(
    persist(
        (set, get) => ({
            /* ---------------------- STATE ---------------------- */

            ...initialState,

            /* ---------------------- SETTERS ---------------------- */

            setData: (data) => set({ data }),
            setPieces: (pieces) => set({ pieces }),
            setBundles: (bundles) => set({ bundles }),
            setIsLoading: (isLoading) => set({ isLoading }),

            /* ---------------------- UTILS ---------------------- */

            startEdit: (id) =>
                set((state) => ({
                    pieces: state.pieces.map((row) => (row.id === id ? { ...row, isEditing: true } : row)),
                })),

            updateBarcode: (id, barcode, isPassing) =>
                set((state) => ({
                    pieces: state.pieces.map((row) =>
                        row.id === id
                            ? { ...row, barcode, code: row.code.toString(), isEditing: true, isPassing }
                            : row,
                    ),
                })),

            cancelEdit: (id) =>
                set((state) => ({
                    pieces: state.pieces.map((row) =>
                        row.id === id ? { ...row, isEditing: false, isPassing: false, barcode: null } : row,
                    ),
                })),

            deletePiece: (id) =>
                set((state) => ({
                    pieces: state.pieces.filter((row) => row.id !== id),
                })),

            startEditBundle: (itemId) =>
                set((state) => ({
                    bundles: state.bundles.map((bundle) => ({
                        ...bundle,
                        items: bundle.items.map((item) => (item.id === itemId ? { ...item, isEditing: true } : item)),
                    })),
                })),

            updateBarcodeBundle: (itemId, barcode, isPassing) =>
                set((state) => ({
                    bundles: state.bundles.map((bundle) => ({
                        ...bundle,
                        items: bundle.items.map((item) =>
                            item.id === itemId
                                ? {
                                      ...item,
                                      barcode,
                                      code: item.code?.toString?.() ?? null,
                                      isEditing: true,
                                      isPassing,
                                  }
                                : item,
                        ),
                    })),
                })),

            cancelEditBundle: (itemId) =>
                set((state) => ({
                    bundles: state.bundles.map((bundle) => ({
                        ...bundle,
                        items: bundle.items.map((item) =>
                            item.id === itemId
                                ? {
                                      ...item,
                                      isEditing: false,
                                      isPassing: false,
                                      barcode: null,
                                  }
                                : item,
                        ),
                    })),
                })),

            deleteBundleItem: (itemId) =>
                set((state) => {
                    const updatedBundles = state.bundles
                        .map((bundle) => {
                            const items = bundle.items.filter((item) => item.id !== itemId);

                            return { ...bundle, items };
                        })
                        .filter((bundle) => bundle.items.length > 0);

                    return { bundles: updatedBundles };
                }),

            /* ---------------------- RESETTERS ---------------------- */

            resetMassal: () =>
                set({
                    ...initialState,
                }),
        }),
        {
            name: 'upload:massal-store',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);
